import {
  FETCH_CUSTOMER_CREDIT_REQUEST,
  FETCH_CUSTOMER_CREDIT_SUCCESS,
  FETCH_CUSTOMER_CREDIT_FAILURE
} from './actions';

const initialState = {
  id: null
};

export default function customerCreditReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CUSTOMER_CREDIT_REQUEST:
    case FETCH_CUSTOMER_CREDIT_FAILURE:
      return { ...state, id: null };
    case FETCH_CUSTOMER_CREDIT_SUCCESS:
      return { ...state, id: action.payload.result };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/customerCredit/reducer.js